export default "__VITE_ASSET__DUmvEzWU__"